export const RouteName = (pathname)=>{
    let path_arr = pathname.indexOf("/")>-1? pathname.split("/"):[pathname]
    return path_arr[1];
}